import { DateValue } from '@dfl/mui-react-common';
import { Alert, Box, Typography } from '@mui/material';
import { TransTypography } from 'components/TransTypography';
import { WarningDialog } from 'modules/common/components/WarningDialog';
import { orderDeliveryDueDateColumn, subOrderStatusColumn } from '../../constants/order-columns';
import { subOrderCodeColumn } from 'modules/sales/sub-orders/constants/sub-order.columns';
import { BasicTable } from '@dfl/mui-admin-layout';
import { memo } from 'react';
import { IOrder } from '../../interfaces/IOrder';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onOpenConfirm: () => void;
  order?: IOrder;
  error?: any;
};

const OrderCompleteDialog = ({ isOpen, onClose, onOpenConfirm, order, error }: Props) => {
  return (
    <WarningDialog
      open={isOpen}
      title={<Typography variant='h1' fontWeight={700}>{order?.code}</Typography>}
      subtitle={<DateValue value={order?.createdAt} format='dd/MM/yyyy hh:mm aa' />}
      onClose={onClose}
      onConfirm={onOpenConfirm}
      confirmText='order:header.actions.complete'
    >
      {error &&
        <Alert severity='error' sx={{ mb: 2 }}>
          <TransTypography
            message={error.suborders?.length > 1 ? 'SUBORDER_INVALID_STATUS_PLURAL' : `order:errors:${error?.reference as string}`}
            values={{
              suborderId: error.suborders?.join(', '),
              status: '',
            }}
          />
        </Alert>
      }
      <Box sx={{ mb: 4, '.MuiTable-root': { minWidth: 480 } }}>
        <BasicTable
          columns={[subOrderCodeColumn('subOrder:name', 50), orderDeliveryDueDateColumn, subOrderStatusColumn(true)]}
          data={order?.suborders || []}
        />
      </Box>
    </WarningDialog>
  )
};

export default memo(OrderCompleteDialog);
